import { JSX } from 'react';

import PropTypes from 'prop-types';

import SharedAsset from '@zenbusiness/zui/SharedAsset';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

/**
 * CalloutAsset component for displaying an image asset with responsive sizes.
 *
 * @component
 * @param {object} props - Component props.
 * @param {string} [props.alt=''] - Alternative text for the image.
 * @param {boolean} [props.show=true] - Does not render the image when false.
 * @param {string} [props.name=''] - Name of the image asset without size suffix or extension.
 * @param {object} props.delegated - Additional props to be passed to the SharedAsset component.
 * @returns {JSX.Element} A SharedAsset component.
 */
const CalloutAsset = ({ alt = '', name = '', show = true, ...delegated }) => {
  const { isMobile } = useBreakpoints().sizes;

  if (!show) {
    return null;
  }

  return (
    <SharedAsset
      alt={alt}
      data-testid="callout-asset"
      src={`/s2/raster/${name}-${isMobile ? 'xs' : 'lg'}.png`}
      {...delegated}
    />
  );
};

CalloutAsset.propTypes = {
  alt: PropTypes.string,
  name: PropTypes.string.isRequired,
  show: PropTypes.bool
};

export default CalloutAsset;
